{
  "collect": "採集樣本",
  "track": "追蹤樣本",
  "accession": "受理編號",
  "barcode": "條碼",
  "status": {
    "ordered": "已開立",
    "collected": "已採集",
    "inTransit": "運送中",
    "received": "已接收",
    "processing": "檢驗中",
    "resulted": "已出報告",
    "rejected": "已拒收",
    "in_transit": "運送中"
  },
  "title": "标本",
  "loading": "正在加载标本…",
  "errorState": "无法加载标本。",
  "emptyState": "该患者暂无标本。",
  "noRejectionReason": "已拒收——未记录原因",
  "columns": {
    "accession": "标本号",
    "type": "类型",
    "status": "状态",
    "collected": "采集时间",
    "received": "接收时间",
    "location": "当前位置"
  }
}
